import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import StepperItem from './components/StepperItem';
import OrderMarketplaceForm from './components/OrderMarketplaceForm';
import { steps } from './newOrderStepperData';
import OrderDetailsForm from './components/OrderDetailsForm';
import OrderProductForm from './components/OrderProductForm';
import OrderClientForm from './components/OrderClientForm';
import OrderShippingForm from './components/OrderShippingForm';

const CreateOrderStepper = () => {
  const {
    createNewOrder: {
      step,
      checkedSteps,
      data
    },
  } = useSelector((state) => ({
    createNewOrder: state.createNewOrder,
  }), shallowEqual);

  const content = {
    marketplace: <OrderMarketplaceForm />,
    details: <OrderDetailsForm />,
    product: <OrderProductForm />,
    client: <OrderClientForm />,
    shipping: <OrderShippingForm />,
  };
  // todo: get order by ref id

  return (
    <div className="flex flex-row p-[40px_25px] relative">
      <div className="flex flex-col flex-1 relative">
        <div className="absolute top-[40px] left-[47px] h-[calc(100%-100px)] max-h-[400px]
          w-[1px] border-r border-dashed border-[#DBDFE9] -z-[1]"
        />
        {steps?.map(({
          id, index, title, subTitle
        }) => (
          <StepperItem
            key={id}
            id={id}
            count={index}
            title={title}
            subTitle={subTitle}
            active={id === step}
            checked={checkedSteps?.includes(id)}
          />
        ))}
        {data && (
          <div style={{ fontSize: 9, color: '#99A1B7' }}>
            <span>{data?.title}</span>
            <br />
            <span>
              {`${data?.firstName} `}
            </span>
            <span>{data?.lastName}</span>
            <br />
            <span>{data?.address}</span>
            <span>{`${data?.address2 ? ', ' : ''}${data?.address2}`}</span>
            <br />
            <span>
              {data?.country}
              {', '}
              {data?.state}
              {', '}
              {data?.city}
              {', '}
              {data?.zip}
            </span>
          </div>
        )}
      </div>
      <div className="flex flex-col flex-[2]">
        {content[step]}
      </div>
    </div>
  );
};

export default CreateOrderStepper;
